export enum CookieName {
  SESSION_ID = 'hashed_session_id',
  ANONYMOUS_ID = 'ajs_anonymous_id',
}
